import React, {useContext} from "react"

import CropTable from "../CropTable"
import { UserProfile } from "../."
import { AuthContext } from "../../Auth/Auth"

import "./Dashboard.css"

export default function Dashboard() {
    const {
        currentUser: { email },
    } = useContext(AuthContext)

    return (
        <main className="dashboard">
            <div className="dashboard__table">
                <header className="dashboard__header">
                    <div id="climateai-logo__dashboard" className="dashboard__logo">
                        <a href="/dashboard">
                            <img width="100%" src="/skip-logo.png" />
                        </a>
                    </div>
                    {email === "pacificseeds@climate.ai" && <div className="dashboard__header-demo">Demo account</div>}
                    <UserProfile />
                </header>
                <div className="dashboard__crop-table">
                    <CropTable />
                </div>
                <div className="powered-by">
                    <a className="powered-by__tag" href="https://www.climate.ai" target="_blank">
                        <div>Powered by</div>
                        <img alt="ClimateAI logo" src="/Climate-AI-Color-Logo.png" />
                    </a>
                </div>
            </div>
        </main>
    )
}
